import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { CheckboxField } from 'vetrf-ui';
import { EaeuInfo } from 'api/eaeu/types';
import styles from './TransactionItems.module.scss';

type TransactionItemsProps = {
  transactions: EaeuInfo[];
};

export const TransactionItems = ({ transactions }: TransactionItemsProps) => {
  const { getValues, setValue } = useFormContext();
  return (
    <ul className="item-list">
      {transactions.map(({ transactionType: { id, name } }) => (
        <li
          key={id}
          className={classNames('item-default', styles.checkboxItem)}
          onClick={() => {
            const v = getValues(`transactionTypeIdList[${id}]`);
            setValue(`transactionTypeIdList[${id}]`, !v);
          }}
        >
          <CheckboxField
            fieldClassName="col-xs-1"
            labelClassName="col-xs-11 control-label no-padding-left text-align-left"
            labelText={name}
            name={`transactionTypeIdList[${id}]`}
            defaultValue={false}
          />
        </li>
      ))}
    </ul>
  );
};
